<template>
  <div id="grade-detail" class="h-screen navbar-sticky" @contextmenu.prevent>
    <the-navbar width="100%" :navbarColor="navbarColor" :showLogo="true" :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" />
    <vs-row vs-type="flex" class="content-wrap">
      <vs-col
        class="no-margin"
        vs-order="1"
        vs-type="flex" vs-justify="flex-start" vs-align="left" :vs-lg="iframeWidth" :vs-sm="iframeWidth" vs-xs="12">

          <iframe v-if="resource.type == 4 || resource.task_type == 'project'" width="100%" class="iframe-box" :src="scratchUrl+'?edit#'+taskDetail.project_id" frameborder="0"></iframe>
          <p v-else>暂时只支持Scratch项目评分</p>
      </vs-col>
      <vs-col
        class="action-wrap"
        vs-order="2"
        vs-type="flex" vs-justify="flex-start" vs-align="left" :vs-lg="infoWidth" :vs-sm="infoWidth" vs-xs="12"
      >
          <!-- <div v-if="ishiddenInfo" class="action-bar" @click="showInfo"><feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4"/></div> -->
          <!-- <div v-else class="action-bar" @click="hiddenInfo"><feather-icon icon="ChevronRightIcon" svgClasses="h-4 w-4"/></div> -->
          <div v-if="!ishiddenInfo" class="info-box">
            <p class="title-h">{{ resource.chapter_name }} - {{ resource.name }}</p>
            <p class="margin-top-1 align-bottom"><span class="font-blod">{{ taskDetail.student_name }}</span><span class="margin-left"><feather-icon icon="ClockIcon" class="margin-right" svgClasses="h-4 w-4" />{{ taskDetail.update_time }}</span></p>
            <p class="margin-top-2">班级：{{ taskDetail.class_name }}</p>
            <p>任务类型：{{ taskDetail.type == 'classroom'?'课堂练习':'课后作业' }}</p>
            <vs-divider/>
            <div class="margin-top-2">
              <div v-if="resource.type == 4 || resource.task_type == 'project'">
                <p class="title-h">维度评分</p>
                <p class="margin-top-1 mark-item"> 
                  <span class="margin-right">创新思维</span><star-rating v-model="createRating_5" :show-rating="false" :glow="5" :inline="true" :star-size="20" @rating-selected="setCreateRating"></star-rating>
                  {{ createRating }}
                </p>
                <p class="mark-item">
                  <span class="margin-right">艺术设计</span> <star-rating v-model="artRating_5" :show-rating="false" :glow="5" :inline="true" :star-size="20" @rating-selected="setArtRating"></star-rating>
                  {{ artRating }}
                </p>
                <p class="mark-item">
                  <span class="margin-right">逻辑分析</span> <star-rating  v-model="logicRating_5" :show-rating="false" :glow="5" :inline="true" :star-size="20" @rating-selected="setLogicRating"></star-rating>
                  {{ logicRating }}
                </p>
                <p class="mark-item">
                  <span class="margin-right">编程技术</span> <star-rating v-model="codeRating_5" :show-rating="false" :glow="5" :inline="true" :star-size="20" @rating-selected="setCodeRating"></star-rating>
                  {{ codeRating }}
                </p>
                <div>
                  <p class="margin-top-2 title-h">总分评分<star-rating v-model="totalRating_5" :read-only="true" :show-rating="false" :glow="5" :inline="true" :star-size="24"></star-rating> {{totalRating}}</p>
                </div>
              </div>
              <div v-else>
                <p class="margin-top-2 title-h">
                  <span>评分</span><vs-slider :min="0" :max="100" color="rgb(45, 208, 129)" v-model="otherRating"/>
                  {{ otherRating }} 分
                </p>
              </div>
              <p class="margin-top-2 title-h">评语</p>
              <vs-textarea class="margin-top-1" placeholder="请输入评语，最多200字" counter="200" :counter-danger.sync="counterDanger" v-model="textarea" />
              
              <p class="margin-top-2 title-h">快捷评分</p>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(100,0)">很棒</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(80,0)">给力</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(60,0)">不错</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(40,0)">再认真一点</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(20,0)">加把劲</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(75,1)">技术性强，创意不足</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(75,2)">设计精美，逻辑不足</vs-button>
              <vs-button class="margin-top-1 margin-right padding-1" color="warning" size="small" type="border" @click="setRatingWithBtn(75,3)">逻辑缜密，美感不足</vs-button>
              <vs-row vs-type="flex" class="margin-top-4">
                <vs-col class="no-margin" vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="small" color="warning" class="margin-right width-100 action-btn" @click="saveRating">保存</vs-button>
                </vs-col>
                <vs-col class="no-margin" vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button v-if="nextTask" size="small" color="warning" class="width-100 action-btn" @click="openNextTask">下一份</vs-button>
                </vs-col>
              </vs-row>
              <vs-button class="mt-3" size="small" color="dark" icon-pack="feather" icon="icon-arrow-left-circle" @click="backToCourseDetail">返回课程详情</vs-button>
            </div>
          </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import TheNavbar from '@/layouts/components/TheNavbar.vue';
import StarRating from 'vue-star-rating';
import themeConfig from '@/../themeConfig.js';
import config from '@/config'

import { getStudentTaskDetail, postTaskGrade } from '@/api/school'

export default {
  components: {
    TheNavbar,
    StarRating
  },
  data() {
    return {
      navbarColor: themeConfig.navbarColor || '#fff',
      isNavbarDark: false,
      ishiddenInfo: false,
      iframeWidth: 9,
      infoWidth: 3,
      textarea: "",
      counterDanger: false,
      chapterId: 0,
      courseId: 0,
      // 用于展示分数的数据
      createRating: 0,
      artRating: 0,
      logicRating: 0,
      codeRating: 0,
      otherRating: 0,
      taskDetail: {
        id: '',
        user_id: '',
        student_name: "",
        update_time: "",
        class_name: "",
        type: "HAAI编辑器",
      },
      resource: {
        chapter_name: '',
        name: '',
        task_type: '',
        type: 0,
      },
      nextTask: null,
      scratchUrl: config.scratchUrl
      
    }
  },
  mounted() {
    this.taskDetail.id = this.$route.query.id;
    this.chapterId = this.$route.query.chapterId;
    this.courseId = this.$route.query.courseId;
    this.init();
  },
  computed: {
    isThemeDark(val) {
      if(this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a")
      }else {
        this.updateNavbarColor("#fff")
      }
    },
    totalRating() {
      return this.createRating + this.artRating + this.logicRating + this.codeRating;
    },
    totalRating_5() {
      return this.totalRating / 20;
    },
    createRating_5() {
      return this.createRating / 5;
    },
    artRating_5() {
      return this.artRating / 5;
    },
    logicRating_5() {
      return this.logicRating / 5;
    },
    codeRating_5() {
      return this.codeRating / 5;
    }
  },
  methods: {
    init() {
      getStudentTaskDetail({
        id: this.taskDetail.id
      }).then(res => {
        if (res.code == 1) {
          this.resource = res.data.resource
          this.taskDetail = res.data.task
          this.nextTask = res.data.next_task
          if (this.resource.type == 4 || this.resource.task_type == 'project') {
            if (res.data.task.score_item) {
              let scoreItem = JSON.parse(res.data.task.score_item)
              this.createRating = parseInt(scoreItem.create)
              this.artRating = parseInt(scoreItem.art)
              this.logicRating = parseInt(scoreItem.logic)
              this.codeRating = parseInt(scoreItem.code)
            }
          } else {
            this.otherRating = parseInt(res.data.task.score)
          }
        }
      })
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if(val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    backToList(){
      this.$router.push({path: '/works/list'})
    },
    setCreateRating(rating){
      this.createRating = rating * 5;
    },
    setArtRating(rating){
      this.artRating = rating * 5;
    },
    setLogicRating(rating){
      this.logicRating = rating * 5;
    },
    setCodeRating(rating){
      this.codeRating = rating * 5;
    },
    saveRating() {
      let postObj = {
        id: this.taskDetail.id,
        score: this.totalRating,
        comment: this.textarea
      }
      if (this.resource.type == 4 || this.resource.task_type == 'project') {
        let scoreItem = { 
          create: this.createRating, 
          art: this.artRating, 
          logic: this.logicRating,
          code: this.codeRating
        }
        postObj['score_item'] = scoreItem
      } else {
        postObj.score = this.otherRating
      }
      postTaskGrade(postObj).then(res => {
        if (res.code == 1) {
          this.$vs.notify({
            color: "success",
            text: "评分成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      })
      
    },
    setRatingWithBtn(level,type) {
      switch (type) {
        case 0:
          this.createRating = level / 4;
          this.artRating = level / 4;
          this.logicRating = level / 4;
          this.codeRating = level / 4;
          if (level == 100) this.textarea = "太棒了！作品极具创意，设计感强，逻辑清晰！";
          if (level == 80) this.textarea = "太给力了！发挥创意和编程能力，作品充分运用课程所学内容！";
          if (level == 60) this.textarea = "本次作品效果不错，能够运用课程所学知识，按照要求完成作品，表扬！";
          if (level == 40) this.textarea = "本次作品还有上升空间，可以再认真一点做出更好的作品哦！";
          if (level == 20) this.textarea = "再加把劲吧，你会做的更好呦！";
          break;
        case 1:
          this.createRating = 15;
          this.artRating = 15;
          this.logicRating = 20;
          this.codeRating = 25;
          this.textarea = "本作品极具创新和编程技巧，继续加油！";
          break;
        case 2:
          this.createRating = 20;
          this.artRating = 25;
          this.logicRating = 15;
          this.codeRating = 15;
          this.textarea = "十分精美的作品！艺术设计感强，让人赏心悦目！";
          break;
        case 3:
          this.createRating = 15;
          this.artRating = 15;
          this.logicRating = 25;
          this.codeRating = 20;
          this.textarea = "你是当之无愧的逻辑大师！作品逻辑缜密，极具操作性！";
          break;
        default:
          break;
      }
      
    },
    openNextTask() {
      console.log(this.nextTask.id)
      getStudentTaskDetail({
        id: this.nextTask.id
      }).then(res => {
        if (res.code == 1) {
          this.resource = res.data.resource
          this.taskDetail = res.data.task
          this.nextTask = res.data.next_task
          if (this.resource.type == 4 || this.resource.task_type == 'project') {
            if (res.data.task.score_item) {
              let scoreItem = JSON.parse(res.data.task.score_item)
              this.createRating = parseInt(scoreItem.create)
              this.artRating = parseInt(scoreItem.art)
              this.logicRating = parseInt(scoreItem.logic)
              this.codeRating = parseInt(scoreItem.code)
            } else {
              this.createRating = 0
              this.artRating = 0
              this.logicRating = 0
              this.codeRating = 0
            }
          } else {
            this.otherRating = parseInt(res.data.task.score)
          }
        }
      })
    },
    backToCourseDetail() {
      this.$router.push({path: '/courseCenter/detail', query: {id: this.chapterId, courseId: this.courseId}})
    },
    hiddenInfo() {
      this.ishiddenInfo = true;
      this.infoWidth = 1;
      this.iframeWidth = 11;
    },
    showInfo() {
      this.ishiddenInfo = false;
      this.infoWidth = 3;
      this.iframeWidth = 9;
    }
  }
}
</script>

<style lang="scss">
#grade-detail {
  background: #fff;
  overflow: hidden;
  .vx-navbar-wrapper {
    width: 100% !important;
  }
  .vs-navbar.vx-navbar {
    width: 100% !important;
  }
  .content-wrap{
    padding-top: 4.4rem;
    height: 100%;
    width: 100%;
    .no-margin{
      margin-bottom: 0;
      padding: 0;
    }
    .action-wrap{
      position: relative;
      height: 100%;
      padding: 0;
      .action-bar{
        width: 20px;
        height: 32px;
        background-color: #333;
        color: #fff;
        text-align: center;
        line-height: 35px;
        border-bottom-left-radius: 15px;
        border-top-left-radius: 15px;
        position: absolute;
        left: -1.4rem;
        top: 200px;
        cursor: pointer;
        z-index: 410001;
      }
      .info-box{
        padding: 1rem;
        width: 100%;
        overflow-y: scroll;
        .title-h{
          font-size: 1.5rem;
          font-weight: bold;
          color: #333;
        }
        .mark-item{
          font-size: 1rem;
          height: 25px;
          line-height: 20px;
        }
        .action-btn{
          padding: 0.5rem 0.8rem;
        }
      }
    }
  }
}
.content-wrap .iframe-box{
  z-index: 410000;
}
.padding-1{
  padding: .679rem 1.2rem;
}
.margin-top-1{
  margin-top: 0.5rem;
}
.margin-top-2{
  margin-top: 0.8rem;
}
.margin-top-4{
  margin-top: 1.6rem;
}
.margin-left{
  margin-left: 1rem;
}
.margin-right{
  margin-right: 0.5rem;
}
.align-bottom{
  vertical-align: bottom;
}
.font-blod{
  font-size: 1.2rem;
  font-weight: bold;
}
.width-100{
  width: 100%;
}
</style>